import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-modalbootstrap',
  templateUrl: './modalbootstrap.component.html',
  styleUrls: ['./modalbootstrap.component.css']
})


export class ModalbootstrapComponent implements OnInit {
  @Input() title: string;
  @Input() detail: string;
  constructor() { }

  ngOnInit() {
  }

}
